import axios from 'axios';
import { getRawApiKey, clearSession } from '../utils/storage';

const baseURLs = {
  local: 'http://localhost:3000',
  web: 'https://finance.kaaryaalaya.com'
};

const environment = process.env.NODE_ENV === 'production' ? 'web' : 'web';

export const getURL = () => baseURLs[environment];

export const getImageURL = (url) => `${getURL()}${url}`;

const axiosClient = axios.create({
  baseURL: getURL(),
  headers: {
    'Content-Type': 'application/json'
  }
});

axiosClient.interceptors.request.use((config) => {
  if (config.skipAuth) {
    return config;
  }

  const apiKey = getRawApiKey();
  if (apiKey) {
    config.headers['x-api-key'] = apiKey;
    config.__hadApiKey = true;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 && error?.config?.__hadApiKey) {
      clearSession();
      window.dispatchEvent(new CustomEvent('session-expired'));
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
